import React from "react";
import _ from "lodash";
import {message, Modal} from "antd";
import queryString from "query-string";
import {update, reset} from "../../viewmodel/swjwLoginMainViewModel";
import HzwjwService from "../../service/noAuth/HzwjwService";
import HzwjwUserService from "../../service/noAuth/hzwjw/UserService";
import ClientSelectActions from "../other/ClientSelectActions";
import TokenService from "../../service/sso/TokenService";


const init = () => {
    return async (dispatch, getState) => {
        const {loginType, nfdata} = queryString.parse(location.search);
        try {
            dispatch(update({
                loading: true,
            }));
            if (loginType && nfdata) {
                const res = await HzwjwUserService.decryptUserAsync({
                    nfdata,
                });
                if (_.size(res) === 1) {
                    const user = res[0];
                    await HzwjwService.noLoginAsync({
                        userId: user.id,
                    });
                    if (user.hospital.id === "ROOT") {
                        const {token: ssoToken} = await TokenService.getTokenAsync({
                            userId: user.id,
                        });
                        const url = new URL("cms/pc/swjwindex.html", location.origin);
                        url.searchParams.set("sso_token", ssoToken);
                        location.replace(url.toString());
                    } else {
                        const url = new URL("renyuan/pc/index.html", location.origin);
                        location.replace(url.toString());
                    }
                } else {
                    dispatch(ClientSelectActions.update({
                        hospitals: res,
                    }));
                    dispatch(update({
                        isClientSelect: true,
                        swjwLogin: false,
                    }));
                }
            }
        } finally {
            dispatch(update({
                loading: false,
            }));
        }
    };
};


export default {
    init,
    update,
    reset,
};
